module.exports = __webpack_public_path__ + "img/icon-mobile.a59e8c29.svg";